import { render } from "./InputColor.vue?vue&type=template&id=6bd3e8c9&scoped=true"
import script from "./InputColor.vue?vue&type=script&lang=js"
export * from "./InputColor.vue?vue&type=script&lang=js"

import "./InputColor.vue?vue&type=style&index=0&id=6bd3e8c9&scoped=true&lang=scss"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bd3e8c9"]])

export default __exports__